// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_fi-0";
export var fileCarousel = "_fi-2";
export var removeFileButton = "_fi-1";